import { MONTHS } from 'config';
import { Month } from 'enums';

export const getCurrentMonth = (): Month => {
  const month = new Date().getMonth();

  return MONTHS[month] as Month;
};

export type Season = 'spring' | 'summer' | 'fall' | 'winter';

export const getCurrentSeason = (): Season => {
  const month = new Date().getMonth();
  if (month >= 2 && month <= 4) return 'spring';
  if (month >= 5 && month <= 7) return 'summer';
  if (month >= 8 && month <= 10) return 'fall';
  return 'winter';
};

export const getIsCloseButtonLight = (month: Month) =>
  month === 'February' || month === 'October' || month === 'December';

export const getIsTextLight = (month: Month) =>
  month === 'January' || month === 'October' || month === 'December';
